module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/ravenna.b36820137c3dad4bc67e4ccb8593988c.jpg";